import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColoredText',
  props: {
    variant: {}
  },
  setup(__props: any) {

const props = __props;

const VARIANTS = {
  gray: 'text-gray-500',
  yellow: 'text-brand-500',
  green: 'text-success-500',
  blue: 'text-blue-300',
  pink: 'text-pink-300',
  orange: 'text-orange-300',
  light_blue: 'text-sky-300',
} as const;

function isValidVariant(variant: string): variant is keyof typeof VARIANTS {
  return variant in VARIANTS;
}

const textColor = computed(() => {
  if (props.variant === null) {
    return VARIANTS.gray;
  }

  if (isValidVariant(props.variant)) {
    return VARIANTS[props.variant];
  }

  return VARIANTS.gray;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(textColor.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})